import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const WiFiInput = ({ value, onChange }) => {
  const securityOptions = [
    { value: 'WPA', label: 'WPA/WPA2' },
    { value: 'WEP', label: 'WEP' },
    { value: 'nopass', label: 'None (Open Network)' }
  ];

  const handleChange = (field, fieldValue) => {
    onChange({
      ...value,
      [field]: fieldValue
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Icon name="Wifi" size={18} color="var(--color-accent)" strokeWidth={2} />
        <label className="text-sm font-caption font-medium text-foreground">
          Wi-Fi Network Details
        </label>
      </div>
      <Input
        label="Network Name (SSID)"
        type="text"
        value={value?.ssid || ''}
        onChange={(e) => handleChange('ssid', e?.target?.value)}
        placeholder="MyWiFiNetwork"
        required
      />
      <Input
        label="Password"
        type="password"
        value={value?.password || ''}
        onChange={(e) => handleChange('password', e?.target?.value)}
        placeholder="Enter network password"
        description="Leave empty for open networks"
      />
      <Select
        label="Security Type"
        options={securityOptions}
        value={value?.security || 'WPA'}
        onChange={(selectedValue) => handleChange('security', selectedValue)}
      />
      <div className="flex items-start gap-2 p-3 rounded-lg bg-muted/30 border border-border">
        <Icon name="Info" size={16} color="var(--color-muted-foreground)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
        <p className="text-xs font-caption text-muted-foreground leading-relaxed">
          Users can scan this QR code to automatically connect to your Wi-Fi network without manually entering credentials.
        </p>
      </div>
    </div>
  );
};

export default WiFiInput;